import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import CONFIG from '../config'
import { AuthenticationService } from './authentication.service'
import { Platform } from '@ionic/angular';
import { HTTP } from '@ionic-native/http/ngx'
import { from } from 'rxjs';
import enviarToken from '../iterceptorNative';

@Injectable({
  providedIn: 'root'
})
export class EvidenciaObacService {

  constructor(public httpNative: HTTP, public http: HttpClient, public platform: Platform) { }
  guardarEvidencia(datos){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/evidenciasOBAC', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/evidenciasOBAC', datos)
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  imagesMultiples(datos){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/evidencias/imagesMultiples', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/evidencias/imagesMultiples', datos)
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }
  verEvidenciasXReporte(idReporte){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/evidenciasOBAC/'+idReporte, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/evidenciasOBAC/'+idReporte)
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  eliminarEvidencia(id){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.delete(CONFIG.API + '/api/evidencias/'+id, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.delete(CONFIG.API + '/api/evidencias/'+id )
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  modificarHoraEvidencia(id,hora){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.put(CONFIG.API + '/api/evidencias/'+id, {hora:hora}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.put(CONFIG.API + '/api/evidencias/'+id,{hora:hora} )
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  reemplazarImagen(id, datos){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.put(CONFIG.API + '/api/evidenciasOBAC/'+id, datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.put(CONFIG.API + '/api/evidenciasOBAC/'+id, datos )
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  getEvidencia(id){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.get(CONFIG.API + '/api/evidenciasOBAC/get/'+id, {}, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.get(CONFIG.API + '/api/evidenciasOBAC/get/'+id )
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  uploadWeb(datos){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/evidenciasOBAC/upload-web/', datos, enviarToken())
        from(nativeCall).pipe()
          .subscribe((data: any) => {
            resolve(JSON.parse(data.data))
          }, err => {
            console.log(err);
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/evidenciasOBAC/upload-web/', datos )
          .subscribe((reporte: any) => {
            resolve(reporte)
          }, (err) => {
            console.log(err)
            reject(err)
          })
      })
    }
  }

  uploadWebMultiple(datos){
    if (this.platform.is('cordova')) {
      return new Promise((resolve, reject) => {
        let nativeCall = this.httpNative.post(CONFIG.API + '/api/evidenciasOBAC/upload-web-multiple/', datos, enviarToken())
        from(nativeCall).pipe()
            .subscribe((data: any) => {
              resolve(JSON.parse(data.data))
            }, err => {
              console.log(err);
            })
      })
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(CONFIG.API + '/api/evidenciasOBAC/upload-web-multiple/', datos )
            .subscribe((reporte: any) => {
              resolve(reporte)
            }, (err) => {
              console.log(err)
              reject(err)
            })
      })
    }
  }
  
}
